export default {
  profileMetadata: {
    companyPlaceholder: 'Выберите компанию',
    successMessages: {
      changeMetadataUser: 'Данные профиля успешно изменены',
      changePhone: 'Номер телефона успешно изменён',
      approveEmail: 'Почта успешно изменена',
      changeEmail: 'Письмо с подтверждением отправлено на указанную эл.почту',
    },
    errorMessages: {
      changeMetadataUser: 'Не удалось изменить данные профиля',
      changeAvatar: 'Не удалось загрузить аватар',
      changeSpecialization: 'Не удалось изменить специализации',
      changePhone: 'Не удалось изменить номер телефона',
      changeEmail: 'Не удалось изменить почту',
    },
    changeUserButton: 'Редактировать профиль',
    accountSettings: 'Настройки аккаунта',
    formLabels: {
      email: 'Новая почта',
      phone: 'Новый номер телефона',
      code: 'Код подтверждения',
    },
    currentUserEmployersDescription: 'Компании, в которых я числюсь сотрудником',
    userEmployersDescription: 'Компании, в которых пользователь числится сотрудником',
    noEmployers: 'Нет компаний',
  },
};
